import htmr from "htmr";

import { Text, View } from "@ctv/shared-core/src";

import { termsAndConditionsStyles as styles } from "../styles";
import { NumberSection } from "../types";
import { AlphabethsRenderer } from "./AlphabethsRenderer";

type Props = {
  numberSections?: NumberSection[];
};

export default function NumbersRenderer(props: Props) {
  const { numberSections } = props;

  if (!numberSections || numberSections.length === 0) {
    return null;
  }

  return (
    <>
      {numberSections.map((numberSection, index) => (
        <View key={index} row>
          <Text style={styles.list} variant="ui-small">
            ({index + 1})
          </Text>
          <View spacing="m" flex gapSpacing>
            <Text style={styles.justify} variant="ui-small">
              {htmr(numberSection.text)}
            </Text>
            <AlphabethsRenderer
              alphabethSections={numberSection.alphabethSection}
            />
          </View>
        </View>
      ))}
    </>
  );
}
